import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { ContentFeedView, TimeRangeEditor } from '..';
import Box from '../layout/Box';
import Icon from '../widgets/Icon';
import Switch from '../widgets/Switch';
import './styles.scss';

const ScheduleEntryView = ({
                             timeSlot,
                             editing,
                             smartBoardEnabled,
                             error,
                             overlaps,
                             onContentFeedChange,
                             onBringToFrontChange,
                             onTimeSlotChange,
                             onDelete,
                             profile,
                             deviceGroup
                           }) => (
  <Box direction="column" className={classNames('schedule-entry', {'overlaps': overlaps})}>
    <Box direction="row">
      <TimeRangeEditor timeRange={timeSlot} editing={editing}
                       onTimeRangeChange={onTimeSlotChange}/>
      <ContentFeedView
      deviceGroup={deviceGroup}
      profile={profile}
      feed={timeSlot.content} onChange={onContentFeedChange}/>
      {smartBoardEnabled &&
      <Switch label="Bring to Front"
              size="large"
              className="bring-to-front"
              checked={timeSlot.bring_to_front}
              onChange={({currentTarget}) =>
                onBringToFrontChange({...timeSlot, bring_to_front: currentTarget.value})}
              formId={`time-slot-btf-${timeSlot.id}`}/>}
      <Icon title="Delete" name="trash-o" size="2rem" onClick={() => onDelete(timeSlot)}/>
    </Box>
    <div className="error">{error}</div>
  </Box>
);

ScheduleEntryView.propTypes = {
  smartBoardEnabled: PropTypes.bool,
  timeSlot: PropTypes.object.isRequired,
  onContentFeedChange: PropTypes.func.isRequired,
  onTimeSlotChange: PropTypes.func.isRequired,
  onBringToFrontChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  editing: PropTypes.bool,
  error: PropTypes.string,
  overlaps: PropTypes.bool,
};

ScheduleEntryView.defaultProps = {
  editing: false,
};

export default ScheduleEntryView;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/ScheduleEntryView/index.js